import FaqsModel from '../Apis/Faqs'
import Controller from './Controller'

export default class FaqsController extends Controller {
  constructor() {
    super(new FaqsModel())
  }
}
